/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_WristInputs */

const en_us2_profile_editors_pain_area_wrist = /** @type {(inputs: Profile_Editors_Pain_Area_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrist`)
};

const pt_br2_profile_editors_pain_area_wrist = /** @type {(inputs: Profile_Editors_Pain_Area_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punho`)
};

const es_419_profile_editors_pain_area_wrist = /** @type {(inputs: Profile_Editors_Pain_Area_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muñeca`)
};

const pt_pt2_profile_editors_pain_area_wrist = /** @type {(inputs: Profile_Editors_Pain_Area_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulso`)
};

const fr_fr2_profile_editors_pain_area_wrist = /** @type {(inputs: Profile_Editors_Pain_Area_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poignet`)
};

const de_de2_profile_editors_pain_area_wrist = /** @type {(inputs: Profile_Editors_Pain_Area_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handgelenk`)
};

const it_it2_profile_editors_pain_area_wrist = /** @type {(inputs: Profile_Editors_Pain_Area_WristInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polso`)
};

/**
* | output |
* | --- |
* | "Wrist" |
*
* @param {Profile_Editors_Pain_Area_WristInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_wrist = /** @type {((inputs?: Profile_Editors_Pain_Area_WristInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_WristInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_wrist(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_wrist(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_wrist(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_wrist(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_wrist(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_wrist(inputs)
	return en_us2_profile_editors_pain_area_wrist(inputs)
});
export { profile_editors_pain_area_wrist as "profile-editors.pain_area_wrist" }